import React from 'react';


function AllRights(props) {


    return (
        <>
            <div class="footer-bottom">
                <div class="container">
                    <div class="copy_right">
                        کليه حقوق محصولات و محتوای اين سایت متعلق به بیت کالا می باشد و هر گونه کپی برداری از محتوا و محصولات سایت پیگرد قانونی دارد
            </div>
                    <div class="social_link">
                        <a href="https://www.facebook.com/bitkala" rel="me"><i class="fab fa-facebook-square"></i></a>
                        <a href="https://www.instagram.com/bitkala.ir/" rel="me"><i class="fab fa-instagram"></i></a>
                        <a href="https://bitkala.ir/feed/articles" rel="me"><i class="fas fa-rss-square"></i></a>
                        <a href="https://twitter.com/bitkala" rel="me"><i class="fab fa-twitter-square"></i></a>
                        <a href="https://t.me/bitkala_ir" rel="me"><i class="fab fa-telegram"></i></a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AllRights;